angular.module('files')
    .directive('fileList', function ($rootScope, $filter, Language, toastr, $http, FileService, FilesSimpleUploadService, FileAssociationService, FileAssociation, FilesLibrary) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                resource: '='
            },
            templateUrl: 'app/files/file-list-resource-full.html',
            link: function (scope, element, attr) {

                scope.filters = {};
                reloadFiles();

                Language.getActive().then(items => scope.langs = items);

                scope.edit = file => FileService.editModal(file).then(() => $rootScope.$broadcast('file.saved'));

                scope.unbindFileFromResource = resource => scope.unbind(resource);

                scope.setLanguage = (association, newLanguage) => {
                    association.language = newLanguage;
                    $http.post('/crm/api/file-association-product/' + scope.resource.id + '/files/' + association.id + '/language', association).then(function (response) {
                        toastr.success("Zapisano zmianę w pliku " + response.data.file.filename);
                    });
                };

                scope.unsetLanguage = association => scope.setLanguage(association, null);

                scope.setOfferBindable = association => {
                    $http.post('/crm/api/file-association-product/' + scope.resource.id + '/files/' + association.id + '/offer', association).then(function (response) {
                        toastr.success("Zapisano zmianę w pliku " + response.data.file.filename);
                    });
                };

                scope.bind = () => FilesLibrary.openAndBind(scope.resource);
                scope.upload = () => FilesSimpleUploadService.open(scope.resource);
                scope.unbind = fileAssociation => FileAssociationService.unbind(fileAssociation, scope.resource);

                scope.reloadFiles = () => reloadFiles();

                scope.clear = () => {
                    scope.filters = {};
                    reloadFiles();
                };

                scope.pageChanged = () => scope.filters.page = scope.page.pageNumber;

                scope.$on("file.saved", () => reloadFiles());

                function reloadFiles() {
                    let params = angular.copy(scope.filters);
                    params.type = $filter('lowercase')(scope.resource.type);
                    params.id = scope.resource.id;

                    FileAssociation.get(params, response => {
                        scope.page = response;
                    });
                }
            }
        };
    });
